import type { ApiServiceInterface, SentryService } from '@travelata-libs/utils';
import Vue from 'vue';
import type { Store } from 'vuex';
import ClientOnly from '@/shared/ui/ClientOnly.vue';
import { container } from './Container';
import { API_SERVICE_TOKEN, APP_CONFIG_TOKEN, STORE_TOKEN, TRACKER_TOKEN, SENTRY_SERVICE_TOKEN } from './tokens';
import type { AppConfig, DestinationTracker } from './types';

Vue.component('ClientOnly', ClientOnly);
export interface InitLibraryOptions {
  store: Store<unknown>;
  config: AppConfig;
  apiService?: ApiServiceInterface;
  tracker?: DestinationTracker;
  sentry?: SentryService;
}

export function initLibrary(options: InitLibraryOptions): void {
  container.register(STORE_TOKEN, options.store);
  container.register(APP_CONFIG_TOKEN, options.config);
  if (options.sentry) {
    container.register(SENTRY_SERVICE_TOKEN, options.sentry);
  }
  if (options.apiService) {
    container.register(API_SERVICE_TOKEN, options.apiService);
  }
  if (options.tracker) {
    container.register(TRACKER_TOKEN, options.tracker);
  }
}

export function useSentryService(): SentryService {
  return container.resolve(SENTRY_SERVICE_TOKEN);
}
